import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';

export const useSwitchOrganizationContext = () => {
  return useMutation({
    mutationFn: async ({
      organizationId,
      parentOrganizationId,
    }: {
      organizationId: string;
      parentOrganizationId: string | undefined;
    }) => {
      await apiClient.post(
        '/api/v1/context-switch',
        { body: { organizationId, parentOrganizationId: parentOrganizationId ?? undefined } },
      );
    },
  });
};
